import api from "@/api";

export const estatisticasService = {
  async getMensais(meses = 12) {
    const { data } = await api.get(`/estatisticas/mensais?meses=${meses}`);
    return data;
  },

  async getDetalhe(mes, tipo) {
    const { data } = await api.get(
      `/estatisticas/detalhe?mes=${mes}&tipo=${tipo}`,
    );
    return data;
  },
};
